import React from "react"
import types from "prop-types"
import clsx from "clsx"
import ItemRow from "shared/ItemRow"
import { FlagIcon } from "shared/icons"

const QuestionContainer = ({
  children = null,
  className = "",
  description = undefined,
  flagged = false,
  isNewQuestion = false,
  prompt,
  required = false,
}) => (
  <ItemRow
    className={clsx(className, isNewQuestion && "submission-new-form-question", "screenreader-whitespace")}
    itemRowHeaderContentClassName="item-row-header-content-submission-question"
    itemRowHeaderContent={(
      <>
        <span className={clsx("grow font-medium text-lg text-dark", required && "required-prompt")}>{prompt}</span>
        <div className="flex items-center gap-2">
          {
            flagged && <FlagIcon />
          }
          {
            isNewQuestion && (
              <span className="font-semibold text-sm text-task-form-color px-1.5 py-1 tracking-wide bg-white rounded-md">
                NEW
              </span>
            )
          }
        </div>
      </>
    )}
    itemRowBody={(
      <>
        {
          description && <p className="font-normal text-sm mb-4">{description}</p>
        }
        {children}
      </>
    )}
  />
)

QuestionContainer.propTypes = {
  children: types.node,
  className: types.string,
  description: types.string,
  flagged: types.bool,
  isNewQuestion: types.bool,
  prompt: types.string.isRequired,
  required: types.bool,
}

export default QuestionContainer
